import script from "./inettie.vue?vue&type=script&setup=true&lang=js"
export * from "./inettie.vue?vue&type=script&setup=true&lang=js"

import "./inettie.vue?vue&type=style&index=0&id=d5a1c4d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5a1c4d6"]])

export default __exports__